// This is a hack to make non serializable data work with immer
export function immerUnserializable(nonSerializableObject) {
    return Object.setPrototypeOf(nonSerializableObject, { immerable: false });
}
